<app-header></app-header>
<ion-content #content class="gray-content-bg">
  <div class="note-details-content gray-content-bg">
    <app-note-header [note]="note"></app-note-header>
    <div class="note-container" *ngIf="note?.noteProdNbrs?.length>0">
      <h4 data-cy="product-count-text">
        {{'i18n.tmNotes.productsFound' | translate : { productCount:
        note.noteProdNbrs.length } }}
      </h4>
      <div class="products-list" *ngIf="products?.length">
        <app-tm-note-product-card
          *ngFor="let product of products; trackBy: trackItem; let i = index;"
          [product]="product"
          [note]="note"
          [customer]="customer"
          [isTouchExperience]="isTouchExperience"
          [lnkSrc]="lnkSrc"
          [index]="i"
        >
        </app-tm-note-product-card>
      </div>
    </div>
  </div>
  <app-footer *ngIf="isDesktop"></app-footer>
</ion-content>
